import { render, staticRenderFns } from "./MyKeyBanner.vue?vue&type=template&id=1f93e628&scoped=true"
import script from "./MyKeyBanner.vue?vue&type=script&lang=ts"
export * from "./MyKeyBanner.vue?vue&type=script&lang=ts"
import style0 from "./MyKeyBanner.vue?vue&type=style&index=0&id=1f93e628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93e628",
  null
  
)

export default component.exports